import * as Init from '~/actions/init';
import * as Speech from '~/actions/speech';
import * as Parser from '~/actions/parser';

import SpeechRecognition from '~/libs/SpeechRecognition';

export { Init, Speech, Parser };
